// @flow
import prop from 'ramda/es/prop';
import values from 'ramda/es/values';
import map from 'ramda/es/map';

import { type FormData } from './StatementEditForm';
import { type StatementSubmitType } from './StatementsData';


export const transform2Api = (data: FormData): StatementSubmitType => { // eslint-disable-line import/prefer-default-export
  const { schoolId, recipientIds, subject, content, files } = data;

  return {
    school_id: prop(0, schoolId),
    recipient_ids: recipientIds,
    subject,
    content,
    attached_file_ids: map(prop('id'), values(files)),
  };
};
